{
  "s_light": "chiaro",
  "s_dark": "scuro",
  "nav_explore": "Esplora Zurigo",
  "nav_explore_desc": "Ristoranti, hotel, cosa fare a Zurigo e dintorni, e altro ancora.",
  "nav_home": "inzh.ch",
  "nav_home_desc": "Portale informativo per Zurigo e dintorni",
  "nav_kantonsrat": "Consiglio cantonale",
  "nav_kantonsrat_desc": "Persone, sedute e organi del Consiglio cantonale di Zurigo",
  "nav_about": "Informazioni",
  "nav_about_desc": "Informazioni su inzh.ch, politica sulla privacy e note legali",
  "l_expand": "Vista completa",
  "l_collapse": "Chiudi vista completa",
  "l_back": "Indietro",
  "l_asceding": "Ascendente",
  "l_descending": "Discendente",
  "l_privacy": "Privacy",
  "l_privacy_txt": "inzh.ch memorizza un cookie per salvare la preferenza del tema. Le fonti della mappa interattiva e delle immagini tentano inoltre di impostare cookie di terze parti.",
  "l_impressum": "Note legali",
  "l_page_not_found": "Pagina non trovata / 404",
  "nav_news": "Notizie e comunicazioni",
  "nav_news_desc": "Notizie e informazioni generali da Zurigo e non solo"
}